import { Box, Tabs as MUITabs, Tab } from '@mui/material';
import TabPanel from './TabPanel';

type Props = {
  tabs: { label: string; content: React.ReactNode }[];
  onChange(event: React.SyntheticEvent, newValue: number): void;
  value: number;
};

const Tabs = ({ tabs, onChange, value }: Props) => (
  <Box sx={{ width: '100%' }}>
    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
      <MUITabs value={value} onChange={onChange}>
        {tabs.map(({ label }, index) => (
          <Tab key={index} label={label} id={`tab-${index}`} aria-controls={`tabpanel-${index}`} />
        ))}
      </MUITabs>
    </Box>
    {tabs.map(({ content }, index) => (
      <TabPanel key={index} value={value} index={index}>
        {content}
      </TabPanel>
    ))}
  </Box>
);

export default Tabs;
